import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

// Os ícones podem ser do bootstrap-icons, font-awesome, ou SVGs customizados.
// Por simplicidade, usaremos texto.
library.add(fas);

export default function SidebarItem({ aiModel, handleChangeAiModel, aiModelConfig, aiIconConfig, aiLabelConfig }) {
    return (
        <li className="nav-item">
            {/* Alterado de 'a' para 'button' */}
            <button
                className={`nav-link ${aiModel === aiModelConfig ? "active" : ""}`}
                onClick={() => { handleChangeAiModel(aiModelConfig) }}
            >
                <FontAwesomeIcon className="mr-2" icon={aiIconConfig} /> {aiLabelConfig}
            </button>
        </li>
    );
};